var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeLoud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.94177,19.95343,17.38153,18.7052a9.92273,9.92273,0,0,0-.00006-13.41052l1.56024-1.24817A11.90988,11.90988,0,0,1,18.94177,19.95343ZM14.98615,7.211,13.42407,8.46063a5.17655,5.17655,0,0,1,.00006,7.07868l1.56208,1.24963A7.16564,7.16564,0,0,0,14.98615,7.211Zm-3.992-3.27057L5.79785,8.0293h-3.792v8H5.80371l5.19043,4.00586ZM4.00586,10.0293H6.49121L8.99414,8.05957v7.90527L6.48535,14.0293H4.00586Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeLoud);
export default __webpack_public_path__ + "static/media/Volume-loud.5079a1c15aba026a3364be77b99fe291.svg";
export { ForwardRef as ReactComponent };